/**
 * @see /lib/adweek-patternlab-bootstrap/source/js/js-bottom/init.js
 */
!function(w, $){

    // Initialize your code here. This is included at the very end of all of the JS
    function initializeGalleryMockup(){

        if ( $ && $.fn && $.fn.galleryMockup ){
            $('.gallery-footer').galleryMockup();
        }

    };

    if ( $( 'body' ).hasClass( 'single' ) ){

        if( $( 'body' ).hasClass( 'article-content-loaded' ) ){
            initializeGalleryMockup();
            console.log( 'initializeGalleryMockup called after .article-content-loaded in body tag' );
        } else {
            $( document ).on( 'aw_article_content_loaded', function(){
                initializeGalleryMockup();
                console.log( 'initializeGalleryMockup called after aw_article_content_loaded' );
            } );
        }
    } else {
        initializeGalleryMockup();
        console.log( 'initializeGalleryMockup called without aw_article_content_loaded' );
    }
}(this, jQuery);